<template>
  <div>
    <bottom-bar :hideBotton="zap || modo_catalogo"/>
    <div class="content" :class="{'c-zap': zap || modo_catalogo}">
      <loading v-show="load" :fullscrean="true" text="Carregando os dados"/>
      <div v-show="!load">
        <div class="container">
          <div class="container-logo mb-2">
            <div class="logo-empresa" :style="'background-image: url('+ (empresa.url_capa ? empresa.url_capa : base_cdn + '/static/imgs/default.png') +')'"></div>
            <div class="img-empresa"><img class="shadow-sm" :src="empresa.url_imagem" alt="Informações da empresa"></div>
          </div>
          <div :class="{'border-bottom pb-2 pt-4': empresa.id_theme !== '1'}">
            <div class="my-1 font-weight-bolder small" v-if="empresa.id_theme === '1'">
              <span class="badge badge-success" v-if="empresa.ativo === '1' && empresa.aberto === '1'">ABERTO</span>
              <span class="badge badge-primary" v-else-if="empresa.ativo === '1' && empresa.agendamentos.length">AGENDAMENTO</span>
              <span class="badge badge-secondary" v-else>FECHADO</span>
            </div>
            <h4 class="text-dark font-weight-bolder mb-0" style="width: 70%">{{empresa.nome_fantasia}}</h4>
            <p class="tamanho-1 mb-0" v-html="empresa.descricao_delivery" v-if="empresa.descricao_delivery"></p>
          </div>
          <div class="row no-gutters text-center mt-3 mb-2" v-if="empresa.id_theme === '1'">
            <div class="col pr-1">
              <a href="javascript:" class="text-muted small py-2 menu-info" :class="{'active': menu === 1}" @click="menu = 1">Dados</a>
            </div>
            <div class="col pr-1">
              <a href="javascript:" class="text-muted small py-2 menu-info" :class="{'active': menu === 2}" @click="menu = 2">Horários</a>
            </div>
            <div class="col" v-if="empresa.agendamentos.length">
              <a href="javascript:" class="text-muted small py-2 menu-info" :class="{'active': menu === 3}" @click="menu = 3">Agendamento</a>
            </div>
          </div>
          <div>
            <div v-show="menu === 1">
              <div class="py-2 border-bottom" v-if="empresa.json_config.endereco_empresa === '1'">
                <div class="font-weight-bold text-dark">Endereço:</div>
                <div class="tamanho-1">
                  {{empresa.endereco}}, {{empresa.numero}}, {{empresa.bairro}}<span v-if="empresa.complemento"> ({{empresa.complemento}})</span>, <span class="text-nowrap"> {{empresa.nome_cidade}} - {{empresa.sigla_estado}}</span>
                </div>
              </div>
              <div class="py-2 border-bottom" v-if="empresa.pagamentos">
                <div class="font-weight-bold text-dark">Formas de pagamento:</div>
                <span class="badge bg-white border py-1 px-2 my-1 mr-1 font-weight-normal" v-for="p in empresa.pagamentos">
                  <img :src="p.img_pagamento" alt="Imagem pagamento" class="mr-1" style="width: 22px; height: 16px; object-fit: contain">
                  {{p.nome_pagamento}} <span v-if="p.categoria === '5'">(online)</span>
                </span>
              </div>
              <div class="py-2 border-bottom" v-if="empresa.telefone">
                <div class="font-weight-bold text-dark">Telefone:</div>
                <div class="tamanho-1">
                  <a :href="'tel:' + empresa.telefone" class="text-info font-weight-bold" aria-label="Telefone da empresa">
                    <i class="fa fa-phone"></i> {{empresa.telefone | phone}}
                  </a>
                </div>
              </div>
              <div class="py-2 border-bottom" v-if="empresa.whatsapp">
                <div class="font-weight-bold text-dark">WhatsApp:</div>
                <div class="tamanho-1">
                  <a :href="'https://api.whatsapp.com/send?phone=55' + empresa.whatsapp" target="_blank" class="text-success font-weight-bold">
                    <i class="fa fa-whatsapp"></i> {{empresa.whatsapp | phone}}
                  </a>
                </div>
              </div>
              <div class="py-2 border-bottom" v-if="empresa.tipo_delivery !== '3'">
                <div class="font-weight-bold text-dark" aria-label="Tempo médio para retirar o pedido no local"><span aria-hidden="true">Tempo médio p/ retirar no local:</span></div>
                <div class="tamanho-1">{{empresa.media_retirada | tempo}}</div>
              </div>
              <div v-if="empresa.tipo_delivery !== '2'">
                <div v-if="empresa.geo_disabled === '2'">
                  <div class="py-2 border-bottom d-flex justify-content-between align-items-center" @click="entrega_variavel = !entrega_variavel" v-if="empresa.zonas.length > 1">
                    <div>
                      <div class="font-weight-bold text-dark">Taxa e tempo de entrega</div>
                      <a href="javascript:" class="text-primary"><u>Entregas variáveis</u></a>
                    </div>
                    <button class="btn text-primary">
                      <i class="fa" :class="entrega_variavel ? 'fa-angle-up' : 'fa-angle-down'"></i>
                    </button>
                  </div>
                  <div v-for="r in empresa.zonas" class="border-bottom" style="font-size: 13px" v-show="entrega_variavel || empresa.zonas.length === 1">
                    <div class="py-2">
                      <div class="font-weight-bold text-dark">{{r.nome_zona}}</div>
                      <div>
                        <span v-if="r.taxa_entrega > 0">{{r.taxa_entrega | valor}}</span>
                        <span class="text-success font-weight-bold" v-else>Entrega Grátis</span> / {{r.tempo_entrega | tempo}}
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else-if="empresa.raio_entregas.length > 0">
                  <div class="py-2 border-bottom d-flex justify-content-between align-items-center" @click="entrega_variavel = !entrega_variavel" v-if="empresa.raio_entregas.length > 1">
                    <div>
                      <div class="font-weight-bold text-dark">Taxa e tempo de entrega</div>
                      <a href="javascript:" class="text-primary"><u>Entregas variáveis</u></a>
                    </div>
                    <button class="btn text-primary">
                      <i class="fa" :class="entrega_variavel ? 'fa-angle-up' : 'fa-angle-down'"></i>
                    </button>
                  </div>
                  <div v-for="r in empresa.raio_entregas" class="border-bottom" v-show="entrega_variavel || empresa.raio_entregas.length === 1">
                    <div class="py-2">
                      <div class="font-weight-bold text-dark">
                        <span v-if="empresa.geo_disabled === '1'">Taxa e tempo de entrega</span>
                        <span v-else>Até {{r.raio_entrega / 1000}}Km</span>
                      </div>
                      <div class="tamanho-1">
                        <span v-if="r.taxa_entrega > 0">{{r.taxa_entrega | valor}}</span>
                        <span class="text-success font-weight-bold" v-else>Entrega Grátis</span> / {{r.tempo_entrega | tempo}}</div>
                    </div>
                  </div>
                </div>
                <div class="py-2 border-bottom" v-if="empresa.entrega_gratis === '1'">
                  <div class="font-weight-bold text-success">Entregas grátis</div>
                  <div class="tamanho-1" v-if="empresa.geo_disabled === '0'">Válido até <b>{{empresa.eg_raio / 1000}}km</b></div>
                  <div class="tamanho-1" v-if="empresa.eg_pedido_minimo > 0">Pedido mínimo: <b>{{empresa.eg_pedido_minimo | valor}}</b></div>
                </div>
              </div>
              <div class="py-2 border-bottom" v-if="empresa.pedido_minimo > 0">
                <div class="font-weight-bold text-dark">Pedido mínimo para entrega:</div>
                <div class="tamanho-1">{{empresa.pedido_minimo | valor}}</div>
              </div>
            </div>
            <div v-show="menu === 2">
              <div v-if="horarios.length > 0">
                <div class="py-2 border-bottom" v-for="d in horarios" v-if="d.horarios.length">
                  <div class="font-weight-bold text-dark">{{d.dia | getDay}}</div>
                  <div v-for="h in d.horarios" class="tamanho-1"><span role="timer">{{h.horario_inicio}}</span> até <span role="timer">{{h.horario_fim}}</span></div>
                </div>
              </div>
            </div>
            <div v-show="menu === 3">
              <div v-if="agendamentos.length > 0">
                <div v-for="e in agendamentos" class="py-2 border-bottom" v-if="e.horarios">
                  <div class="font-weight-bold text-dark">{{e.dia | getDay}}</div>
                  <div class="tamanho-1">{{e.horarios}}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-4" v-if="empresa.url_facebook || empresa.url_instagram">
            <redes-sociais :empresa="empresa"/>
          </div>
        </div>
        <ads-le-card full="true"/>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from '../components/Loading'
import BottomBar from '../components/BottomBar';
import AdsLeCard from "../components/AdsLeCard";
import CardInfo from '../components/CardInfo'
import RedesSociais from "../components/RedesSociais";
import Icon from "../components/Icon";

export default {
  name: 'InfoRestaurante',
  components: {Icon, RedesSociais, AdsLeCard, Loading, BottomBar, CardInfo},
  data() {
    return {
      load: true,
      agendamentos: [],
      menu: 1,
      entrega_variavel: false,
      tempo_entrega: '',
      horarios: []
    }
  },

  methods: {
    getDados() {
      this.horarios = ['1','2','3','4','5','6','7'].map(dia => ({
        dia, horarios: this.empresa.horarios.filter(data => data.dia === dia)
      }));

      this.agendamentos = ['1','2','3','4','5','6','7'].map(dia => ({
        dia, horarios: this.getAgendamento(dia)
      }));
    },

    getAgendamento(dia) {
      const horarios = this.empresa.agendamentos.filter(data => data.dia === dia);

      if (horarios.length) {
        let h2 = horarios.length > 1 ? horarios[horarios.length - 1] : horarios[0];
        return `Das ${horarios[0].horario_inicio} às ${h2.horario_fim}`;
      }

      return null;
    },

    getTempoMax() {
      if (this.empresa.raio_entregas && this.empresa.raio_entregas.length) {
        const tempo_min = this.empresa.raio_entregas[0].tempo_entrega;
        const tempo_max = this.empresa.raio_entregas.length > 1 ? this.empresa.raio_entregas[this.empresa.raio_entregas.length - 1].tempo_entrega : tempo_min;
        this.tempo_entrega = tempo_max > tempo_min ? (tempo_min + '-' + tempo_max) : tempo_min;
      }
    }
  },

  created() {
    window.scrollTo(0,0);
    document.body.classList.remove("modal-open");
    this.getDados();
    this.getTempoMax();
    this.load = false;
  },

  computed: {
    empresa() {
      return this.$store.state.empresa
    },

    usuario() {
      return this.$store.state.dataUser
    },

    zap() {
      return this.$store.state.zap
    }
  },

  filters: {
    phone(phone) {
      if (phone) {
        if (phone.length === 10) {
          return phone.replace(/[^0-9]/g, '')
              .replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');

        } else if (phone.length === 11) {
          return phone.replace(/[^0-9]/g, '')
              .replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
        }
      }

      return phone
    }
  }
}
</script>
<style scoped>
.container-logo {
  position: relative;
  height: 140px;
  text-align: center;
  border-radius: 12px;
  border: 6px solid #ffffff;
}

.logo-empresa {
  height: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: var(--lecard-default)!important;
  border-radius: 6px;
}

.img-empresa {
  width: 115px;
  height: 115px;
  background-color: #F4F5F7;
  border: 6px solid #F4F5F7;
  border-radius: 50%;
  position: absolute;
  z-index: 1;
  top: 65px;
  right: 15px;
}

.img-empresa img {
  border-radius: 50%;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

@media (min-width: 1200px) {
  .container-logo {
    height: 260px;
    margin: 0 auto;
  }
  .img-empresa {
    margin-top: 115px;
    width: 140px;
    height: 140px;
  }
}
</style>
